// frontend/src/session/SessionContext.tsx
import React, { createContext, useContext, useState } from 'react';

export type SessionContextValue = {
  context: any | null; // later: SessionContext from backend types
  setContext: (ctx: any | null) => void;
};

const SessionContext = createContext<SessionContextValue | undefined>(undefined);

export function SessionContextProvider({ children }: { children: React.ReactNode }) {
  const [context, setContext] = useState<any | null>(null);

  return (
    <SessionContext.Provider value={{ context, setContext }}>{children}</SessionContext.Provider>
  );
}

export function useSessionContext() {
  const ctx = useContext(SessionContext);
  if (!ctx) {
    throw new Error('useSessionContext must be used inside SessionContextProvider');
  }
  return ctx;
}
